// extracted by mini-css-extract-plugin
export default {"noAccessSection":"styles_noAccessSection__gX+3-","paginationContainer":"styles_paginationContainer__65Te6"};